import { fork, take, call, put, all } from "redux-saga/effects";

import { getAllCoaching, getAllCoachingResponse, getAllCoachingClear } from "./actions";
import types from "./types";
import { postAPIWithoutModule } from "../../api/generic";


export function* doCoaching() {
    while (true) {
      const { payload } = yield take(types.COACHING_LIST);
      const response = yield call(postAPIWithoutModule, payload);
      yield put(getAllCoachingResponse(response));
    }
  }
  
  function* coaching() {
    yield fork(doCoaching);
  }
  
  export default coaching;